import { useGetUserBoardCardConfigQuery } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
// Fetch settings from user customizations stored in DB
export const useLoadBoardCardSectionSettings = ({
  pipelineId,
  objectTypeId,
  appId,
  skip
}) => {
  const {
    loading,
    error,
    data
  } = useGetUserBoardCardConfigQuery({
    skip,
    variables: {
      pipelineId,
      objectTypeId,
      appId
    }
  });
  return {
    loading,
    error,
    data: data === null || data === void 0 ? void 0 : data.boardCardSectionConfigurations
  };
};